import React, {useState} from 'react';
import {FormControl, FormControlLabel, Radio, RadioGroup} from '@mui/material';
import {convertToRoman} from 'app/helpers/convertToRoman';
import {Button, Typography} from '@fupa/fupa-uikit';
import styled from 'styled-components';
import {Dialog} from 'app/components/dialog/Dialog';

const Container = styled.div`
  display: flex;
  margin: 1.5rem 1rem 0.5rem;
  flex-direction: column;
`;

const Info = styled(Typography)`
  padding-bottom: 1rem;
`;

const TeamSelect = ({teams, onResolve, onReject, open}) => {
  const [value, setValue] = useState(teams[0].id.toString());
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const SelectOptions = teams.map((team) => {
    const teamName = team.level > 1 ? team.names.middle + ' ' + convertToRoman(team.level) : team.names.middle;
    return (
      <FormControlLabel key={team.id} value={team.id.toString()} control={<Radio size='small' />} label={teamName} />
    );
  });

  const actionButton = <Button justify='center' onClick={() => onResolve(value)} label='Ok' />;

  return (
    <Dialog
      actionAlign='flex-end'
      actionContent={actionButton}
      closeable={true}
      handleClose={onReject}
      open={open}
      title='Hauptteam auswählen'>
      <FormControl component='fieldset'>
        <Container>
          <Info variant='body1'>
            Das Team ist eine Spielgemeinschaft. Um dem Team saisonübergreifend zu folgen, wähle dein Hauptteam aus.
          </Info>
          <RadioGroup aria-label='teams' name='teams' value={value} onChange={handleChange}>
            {SelectOptions}
          </RadioGroup>
        </Container>
      </FormControl>
    </Dialog>
  );
};

export default TeamSelect;
